module.exports = __webpack_public_path__ + "static/img/qpp.4d8054e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/qpp.jpg
// module id = pA6a
// module chunks = 0